module.exports = __webpack_public_path__ + "img/SiD.d50f91d7.svg";